/* global axios */

const baseUrl = () =>
  `/api/v1/accounts/${window.location.pathname.split('/')[3]}/astrachat/whatsapp_calling`;

export default {
  capability(inboxId, contactId) {
    return axios.get(`${baseUrl()}/capability`, {
      params: { inbox_id: inboxId, contact_id: contactId },
    });
  },
  settings(inboxId, details = false) {
    return axios.get(`${baseUrl()}/settings`, {
      params: { inbox_id: inboxId, ...(details ? { details: true } : {}) },
    });
  },
  updateSettings(inboxId, data) {
    return axios.patch(`${baseUrl()}/settings`, data, {
      params: { inbox_id: inboxId },
    });
  },
  requestPermission(inboxId, contactId) {
    return axios.post(`${baseUrl()}/call_permissions`, {
      inbox_id: inboxId,
      contact_id: contactId,
    });
  },
  connect(inboxId, contactId, session) {
    return axios.post(`${baseUrl()}/calls`, {
      inbox_id: inboxId,
      contact_id: contactId,
      session,
    });
  },
  claim(inboxId, id) {
    return axios.post(`${baseUrl()}/calls/${id}/claim`, { inbox_id: inboxId });
  },
  action(inboxId, id, action, session = null) {
    return axios.post(`${baseUrl()}/calls/${id}/${action}`, {
      inbox_id: inboxId,
      ...(session ? { session } : {}),
    });
  },
};
